export default "__VITE_ASSET__DxWsNU4Y__"